const SFCC_SCAPI_HOST_SUFFIX = '.api.commercecloud.salesforce.com';

export function isValidSfccScapiHost(value: string): boolean {
  try {
    const url = new URL(value);
    return (
      url.protocol === 'https:' &&
      url.hostname.endsWith(SFCC_SCAPI_HOST_SUFFIX) &&
      url.hostname.length > SFCC_SCAPI_HOST_SUFFIX.length &&
      url.port === '' &&
      url.username === '' &&
      url.password === '' &&
      url.pathname === '/' &&
      url.search === '' &&
      url.hash === ''
    );
  } catch {
    return false;
  }
}
